function __initHubUpsellModal() {
  var modal = document.getElementById('HubUpsellModal');
  if (!modal) return;

  var SESSION_KEY = 'hub-upsell-dismissed';
  var pendingCheckoutTarget = null;
  var isCheckingCart = false;

  if (modal.dataset.hubInCart === 'true') {
    sessionStorage.setItem(SESSION_KEY, '1');
  }

  function shouldShow() {
    if (sessionStorage.getItem(SESSION_KEY)) return false;
    if (modal.dataset.isHubMember === 'true') return false;
    return true;
  }

  function openModal() {
    modal.style.setProperty('--m-opacity', '1');
    modal.classList.add('m-open-modal');
    document.documentElement.classList.add('prevent-scroll');
  }

  function closeModal() {
    modal.classList.remove('m-open-modal');
    modal.style.setProperty('--m-opacity', '0');
    document.documentElement.classList.remove('prevent-scroll');
  }

  function proceedToCheckout() {
    sessionStorage.setItem(SESSION_KEY, '1');
    if (modal.classList.contains('m-open-modal')) closeModal();
    if (pendingCheckoutTarget) {
      pendingCheckoutTarget.click();
    }
  }

  function checkCartAndOpenModal(target) {
    if (isCheckingCart) return;
    isCheckingCart = true;
    pendingCheckoutTarget = target;

    fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
      .then(function(response) {
        if (!response.ok) throw new Error('Unable to check cart for Hub membership');
        return response.json();
      })
      .then(function(cart) {
        var hasHubInCart = cart.items.some(function(item) {
          return (item.product_type || '').trim().toLowerCase() === 'hub membership';
        });

        if (hasHubInCart || !shouldShow()) {
          proceedToCheckout();
        } else {
          openModal();
        }
      })
      .catch(function() {
        proceedToCheckout();
      })
      .finally(function() {
        isCheckingCart = false;
      });
  }

  // Intercept checkout button clicks (capture phase, fires before NDIS)
  document.addEventListener('click', function(e) {
    var target = e.target.closest('button[name="checkout"]');
    if (!target) return;
    if (!shouldShow()) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    checkCartAndOpenModal(target);
  }, true);

  // Intercept form submissions (cart page)
  document.addEventListener('submit', function(e) {
    var form = e.target;
    var checkoutBtn = form.querySelector('button[name="checkout"]');
    if (!checkoutBtn) return;
    if (!shouldShow()) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    checkCartAndOpenModal(checkoutBtn);
  }, true);

  // Click outside modal content to dismiss
  modal.addEventListener('click', function(e) {
    if (e.target === modal) {
      sessionStorage.setItem(SESSION_KEY, '1');
      closeModal();
    }
    e.stopPropagation();
  });

  // Close button
  var closeBtn = modal.querySelector('.hub-upsell-modal__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', function() {
      sessionStorage.setItem(SESSION_KEY, '1');
      closeModal();
    });
  }

  // Dismiss button — continue to checkout
  var dismissBtn = modal.querySelector('.hub-upsell-modal__dismiss');
  if (dismissBtn) {
    dismissBtn.addEventListener('click', proceedToCheckout);
  }

  // Sign up button — dismiss, close modal and cart drawer before navigating
  var signupBtn = modal.querySelector('.hub-upsell-modal__signup-btn');
  if (signupBtn) {
    signupBtn.addEventListener('click', function() {
      sessionStorage.setItem(SESSION_KEY, '1');
      closeModal();
      var drawer = document.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.close === 'function') {
        drawer.close();
      }
    });
  }
}
